import { CreateButton } from "react-admin";

function CustomCreateButton() {
  return <CreateButton variant="fieldwire-primary" />;
}

export default CustomCreateButton;
